import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/inquiries");
        setItems(data);
      } catch (e) { console.error(e); }
    })();
  }, []);

  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-wider text-blue-600">Messages</div>
      <h1 className="mt-1 font-display text-3xl font-bold">Customer inquiries</h1>

      <div className="mt-8 space-y-3" data-testid="inquiry-list">
        {items.length === 0 ? (
          <div className="rounded-2xl bg-white border border-slate-200 p-10 text-center text-sm text-slate-500">No inquiries yet.</div>
        ) : items.map(q => (
          <div key={q.id} className="rounded-2xl bg-white border border-slate-200 p-5" data-testid={`inquiry-${q.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <div className="font-display font-semibold text-slate-900">{q.name} <span className="font-normal text-slate-500">· {q.email}</span></div>
                {q.phone && <div className="text-xs text-slate-500 mt-0.5">{q.phone}</div>}
                {q.product_name && (
                  <div className="mt-2 text-xs">
                    <span className="text-slate-500">About: </span>
                    {q.product_id ? <Link to={`/product/${q.product_id}`} className="text-blue-600 font-medium">{q.product_name}</Link> : <span>{q.product_name}</span>}
                  </div>
                )}
              </div>
              <div className="text-xs text-slate-500 font-mono">{new Date(q.created_at).toLocaleString()}</div>
            </div>
            <p className="mt-3 text-slate-700 text-sm whitespace-pre-line">{q.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
